import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    services: {},
    servicesSelectList: [],
    selectedServiceId:"",
    service:{},
    userProfileDetails:{},
    serviceSelectListBasedOnAvailability:[],
    staffSelectListBasedOnAvailability:[]
};


const services = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_SERVICES_LIST: {
      draft.services = payload?.services;
      break;
    }

    case Actions.GET_SERVICES_SELECT_LIST: {
      draft.servicesSelectList = payload?.servicesSelectList?.filter((elem)=>elem.is_active).map((element)=>({...element,value:element?._id, label:element?.title,price:element?.price}));
      break;
    }

    case Actions.GET_SERVICE_SELECT_LIST_BASED_ON_AVAILABILITY: {
      draft.serviceSelectListBasedOnAvailability = payload?.serviceSelectListBasedOnAvailability?.map((element)=>({...element, value:element?._id, label:element?.title, price:element?.price}));
      break;
    }

    case Actions.GET_STAFF_SELECT_LIST_BASED_ON_AVAILABILITY: {
      draft.staffSelectListBasedOnAvailability = payload?.staffSelectListBasedOnAvailability?.map((element)=>({...element, value:element?._id, label:`${element?.first_name || ""} ${element?.last_name || ""}`, price:element?.price}));
      break;
    }

    case Actions.SELECTED_SERVICE_ID: {
      draft.selectedServiceId = payload?.selectedServiceId;
      break;
    }

    case Actions.GET_SERVICE_BY_ID: {
      draft.service = payload?.service;
      break;
    }

    case Actions.GET_USER_PROFILE_DETAILS: {
      draft.userProfileDetails = payload?.userProfileDetails;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default services;
